/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';

import CopySubscriberDialog from 'groups/components/CopySubscriberDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import GroupStore from 'groups/stores/GroupStore';
import MenuItem from 'components/MenuItem.jsx';
import Relationship from 'entities/Relationship';
import Subscriber from 'entities/Subscriber';
import { mountModal } from 'lib/modal';
import { promiseRelationship } from 'chat/utils/ChatPromises';
import errorLogger from 'utils/errorLogger';

class SubscribeUserMenuItem extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    subscriber: PropTypes.instanceOf(Subscriber).isRequired,
    eventElementName: PropTypes.string,
    disabled: PropTypes.bool,
  };

  clickCopyDialog = () => {
    promiseRelationship(this.props.subscriber)
      .then(relationship => {
        this.renderCopyDialog(relationship);
      })
      .catch(errorLogger('SubscribeUserMenuItem clickCopyDialog failed'));
  };

  renderCopyDialog = (relationship: Relationship) => {
    const groups = GroupStore.getOwnedGroups();
    mountModal(<CopySubscriberDialog relationship={relationship} groups={groups} />, this);
  };

  render() {
    return (
      <MenuItem
        onClick={this.clickCopyDialog}
        eventElementName={this.props.eventElementName}
        disabled={this.props.disabled}>
        <Glyph name="arrow-right" />
        <span>Copy to another class</span>
      </MenuItem>
    );
  }
}

export default SubscribeUserMenuItem;
